"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
var TooltipDirection = /* @__PURE__ */ ((TooltipDirection2) => {
  TooltipDirection2["Above"] = "above";
  TooltipDirection2["Left"] = "left";
  TooltipDirection2["Right"] = "right";
  TooltipDirection2["Below"] = "below";
  return TooltipDirection2;
})(TooltipDirection || {});
var TooltipLocation = /* @__PURE__ */ ((TooltipLocation2) => {
  TooltipLocation2["Beginning"] = "beginning";
  TooltipLocation2["Middle"] = "middle";
  TooltipLocation2["End"] = "end";
  TooltipLocation2["Hidden"] = "hidden";
  return TooltipLocation2;
})(TooltipLocation || {});
function Tooltip(props) {
  const directionClass = `v3__tooltip--${props.direction}`;
  const locationClass = `v3__tooltip--${props.location}`;
  return /* @__PURE__ */ jsxs("span", { className: "v3__tooltip--wrapper", style: { cursor: "pointer" }, children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: `v3__tooltip ${directionClass} ${locationClass}`,
        style: props.tooltipContentStyle,
        children: props.tooltipContent
      }
    ),
    props.content
  ] });
}
export { Tooltip, TooltipDirection, TooltipLocation };
